var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEventsAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "sidemenuFillIcon",
    width: 22,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 7.4v10.5c0 1.7-1.3 3-3 3H5.9c0 1.1.9 2 2 2H18c2.2 0 4-1.8 4-4V9.4C22 8.3 21.1 7.4 20 7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 1.1v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12.2c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2h-1v-2h-2v2H7v-2H5zm-1 7h12.2v9H4v-9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.7 16.3l-2.4-1.4L9 16.3l0.6-2.7-2.1-1.8 2.8-0.2L11.4 9l1.1 2.5 2.8 0.3-2.1 1.8 0.5 2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventsAnnouncement);
export default __webpack_public_path__ + "static/media/IconEventsAnnouncement.a124dd089326f7b5547b7d8fb4a41e35.svg";
export { ForwardRef as ReactComponent };